import {
  DraftFetchOutcome,
  QuestionnaireDraftScopedRequest,
} from "../../lib/questionnaire_draft/coordinator";
import {
  questionnaireDraftRequestData,
  runQuestionnaireDraftRequest,
} from "./questionnaire_draft_request";

// Fetches the identity's recovery copy for an editor. The copy goes straight back to the caller --
// never into the store -- and a reply whose session is over is `stale`, so it cannot be offered to
// whoever signed in next.
export function* sendQuestionnaireDraftFetch({
  scope,
  key,
}: QuestionnaireDraftScopedRequest): Generator<any, DraftFetchOutcome, any> {
  const result = yield* runQuestionnaireDraftRequest({
    scope,
    path: "/v1/web/questionnaire-draft-fetch",
    data: questionnaireDraftRequestData(key),
  });
  if (result.kind === "rate_limited") return { kind: "retry" };
  if (result.kind !== "ok") return result;
  const { draft, updatedAt } = result.payload ?? {};
  // nothing stored, expired or evicted: both are null
  if (draft === null || draft === undefined || typeof updatedAt !== "string")
    return { kind: "absent" };
  return { kind: "found", draft, updatedAt };
}
